export const windowLocationAssign = (path: string) => {
    window.location.assign(path);
};
